import { createReducer, on } from "@ngrx/store";
import { ClientSettings } from "src/model/class/client-settings";
import {
  clientSettingInitCompleteAction,
  clientSettingsSetApplicationThemeAction,
  clientSettingsSetDigitalPlaceFlagAction,
  clientSettingsSetSupervisionModeViewAction,
  clientSettingsUpdateAction,
  clientSettingsUpdateAdminFeaturesPasswordAction,
  clientSettingsUpdateAutoRestartOnBootAction,
  clientSettingsUpdateCustomStartingAccessEnvironmentcartegoryAction,
  clientSettingsUpdateDefaultRelayActivationTimeSettingAction,
  clientSettingsUpdateDefaultRelaySettingAction,
  clientSettingsUpdateDeviceNameSettingAction,
  clientSettingsUpdateEnableRemobteLogAction,
  clientSettingsUpdateHelperAction,
  clientSettingsUpdateKioskModeAction,
  clientSettingsUpdateKioskModePasswordAction,
  clientSettingsUpdateLanguageAction,
  clientSettingsUpdateMaximumRelayActivationTimeSettingListAction,
  clientSettingsUpdateMaximumSingleRelayActivationTimeSettingAction,
  clientSettingsUpdateRelayTimeLimitEnablersListAction,
  clientSettingsUpdateRemoteLogLevelAction,
  clientSettingsUpdateShowButtonConnectionExitAction,
  clientSettingsUpdateSiboDeviceIDAction,
  clientSettingsUpdateSingleRelayTimeLimitEnableAction,
  clientSettingsUpdateSpecificSettingAction,
  clientSettingsUpdateSupervisionFontSizeAction,
  clientSettingsUpdateParamBrightness,
  clientSettingsUpdateTimeInactivitySupervision,
  clientSettingsUpdateCardReadingModeAction,
  clientSettingsUpdateEventsBlackBox,
} from "../actions/client-settings.actions";

/**
 * Reducer for client settings
 */
export const ClientSettingsReducer = createReducer(
  null,
  on(
    clientSettingInitCompleteAction,
    (clientSettings: ClientSettings, action) => {
      return action.clientSettings;
    }
  ),
  on(clientSettingsUpdateAction, (clientSettings: ClientSettings, action) => {
    return action.clientSettings;
  }),
  on(
    clientSettingsUpdateSpecificSettingAction,
    (clientSettings: ClientSettings, action) => {
      const currentClientSettings: ClientSettings = new ClientSettings({
        ...clientSettings,
      }); //Recreate object with new reference value
      currentClientSettings[action.settingsName] = action.settingsValue;

      return currentClientSettings;
    }
  ),
  on(
    clientSettingsUpdateDeviceNameSettingAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        deviceName: action.deviceName,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateDefaultRelaySettingAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        defaultRelay: action.defaultRelay,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateDefaultRelayActivationTimeSettingAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        defaultRelayActivationTime: action.defaultRelayActivationTime,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateCardReadingModeAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        cardReadingMode: action.cardReadingMode,
      };
      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateRelayTimeLimitEnablersListAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        isRelayTimeLimitEnableArray: action.enablersTimeLimitList,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateMaximumRelayActivationTimeSettingListAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        relayTimeLimitArray: action.maximumTimeLimitList,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateSingleRelayTimeLimitEnableAction,
    (clientSettings: ClientSettings, action) => {
      let newArrayEnablers: Array<boolean> = [
        ...clientSettings.isRelayTimeLimitEnableArray,
      ];

      newArrayEnablers[action.selctedRelay] = action.enableHardTimeLImit;

      const newClientSettings: ClientSettings = {
        ...clientSettings,
        isRelayTimeLimitEnableArray: newArrayEnablers,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateMaximumSingleRelayActivationTimeSettingAction,
    (clientSettings: ClientSettings, action) => {
      let newArrayTimeLImits: Array<number> = [
        ...clientSettings.relayTimeLimitArray,
      ];

      newArrayTimeLImits[action.selctedRelay] =
        action.maximumRelayActivationTime;

      const newClientSettings: ClientSettings = {
        ...clientSettings,
        relayTimeLimitArray: newArrayTimeLImits,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateParamBrightness,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        enableBrightnessSettings: action.enableBrightnessSettings,
        typeBrightnessSettings: action.typeBrightnessSettings,
        timeBrightness: action.timeBrightness,
        percentageBrightness: action.percentageBrightness,
        defaultBrightness: action.defaultBrightness,
      };
      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateTimeInactivitySupervision,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        timeInactivitySupervision: action.timeInactivitySupervision,
      };
      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateEventsBlackBox,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        numberEventsBlackBox: action.numberEventsBlackBox,
      };
      return newClientSettings;
    }
  ),
  /*
    on(
      clientSettingsUpdateRelayTimeLimitEnableAction,
      (clientSettings: ClientSettings, action) => {
        const newClientSettings: ClientSettings = {
          ...clientSettings,
          isRelayTimeLimitEnable: action.enableHardTimeLImit,
        };
  
        return newClientSettings;
      }
    ),
    on(
      clientSettingsUpdateMaximumRelayActivationTimeSettingAction,
      (clientSettings: ClientSettings, action) => {
        const newClientSettings: ClientSettings = {
          ...clientSettings,
          relayTimeLimit: action.maximumRelayActivationTime,
        };
  
        return newClientSettings;
      }
    ),
    */

  on(
    clientSettingsUpdateHelperAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        helpAlreadyViewForUser: action.helpers,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateSupervisionFontSizeAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        supervisionFontSize: action.fontSize,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateSiboDeviceIDAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        idDevice: action.idDevice,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateKioskModeAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        kioskMode: action.kioskMode,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsSetSupervisionModeViewAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        supervisionListViewMode: action.viewMode,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateLanguageAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        language: action.lang,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateShowButtonConnectionExitAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        isConnectionLostExitButtonEnabled: action.showButtonCommandExit,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateKioskModePasswordAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        kioskModePassword: action.kioskModePassword,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateAdminFeaturesPasswordAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        adminDevicePassword: action.adminFeaturesPassword,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateAutoRestartOnBootAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        isAutoStartOnBootUpON: action.autoStartOnReboot,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateCustomStartingAccessEnvironmentcartegoryAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        customStartingAccessEnvironmentCategory: action.accessCategory,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateEnableRemobteLogAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        remoteLogEnable: action.enableRemoteLog,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsUpdateRemoteLogLevelAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        remoteLogLevel: action.remoteLogLevel,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsSetApplicationThemeAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        theme: action.theme,
      };

      return newClientSettings;
    }
  ),
  on(
    clientSettingsSetDigitalPlaceFlagAction,
    (clientSettings: ClientSettings, action) => {
      const newClientSettings: ClientSettings = {
        ...clientSettings,
        isDigitalPlace: action.isDigitalPlace,
      };

      return newClientSettings;
    }
  )
);
